<div class="inner">
    <div class="stickyContent"
         [class.no-shadow]="noShadow"
         [elementHeight]="uid">
        <ng-content></ng-content>
    </div>
</div>